
/**
 * Local storage utilities for session persistence
 */

export const storage = {
  // Session ID management
  getSessionId: (): string => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = `session_${Date.now()}`;
      localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  },

  // User profile management
  getUserProfile: () => {
    const profile = localStorage.getItem('userProfile');
    return profile ? JSON.parse(profile) : null;
  },

  setUserProfile: (profile: any) => {
    localStorage.setItem('userProfile', JSON.stringify(profile));
  },

  // Chat history (last few messages for context)
  getChatHistory: (): any[] => {
    const history = localStorage.getItem('chatHistory');
    return history ? JSON.parse(history) : [];
  },

  setChatHistory: (messages: any[]) => {
    // Only store last 10 messages
    const recentMessages = messages.slice(-10);
    localStorage.setItem('chatHistory', JSON.stringify(recentMessages));
  },

  // Clear all storage
  clearAll: () => {
    localStorage.removeItem('sessionId');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('chatHistory');
  }
};
